import(/* webpackMode: "eager" */ "/vercel/path0/src/app/masjids/[slug]/volunteer/page.tsx");
